var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FullBack',[_c('ColumnLayout',{staticClass:"py-8 pt-16"},[_c('SectionBanner',{attrs:{"text":"Frequently Asked Questions"}})],1)],1),_c('ColumnLayout',{staticClass:"px-0 pa-sm-8 py-8"},[_c('AccordionList',{staticClass:"px-0",attrs:{"items":_vm.items2,"title":_vm.title}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }